<aims-common-table id="jobTitles-table" [dataSource]="jobTitles| async" [header]="jobTitlesHeader" [pageSize]="10"
  [permissions]="tablePermissions" [addRowInitialObject]="initialTableElement" (rowUpdated)="handleRowUpdate($event)"
  (rowAdded)="handleRowAdd($event)">

  <aims-common-table-dynamic-row id="workSectionId">
    <ng-template viewMode let-element>{{ element.workSectionId |
      getText:'workSectionId':'workSection':workSectionValues |
      async}}
    </ng-template>
    <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="top10 fullWidth">
        <mat-label>Work Section</mat-label>
        <mat-select [formControl]="dynamicControl">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of workSectionValues | async" [value]="val.workSectionId">
            {{val.workSection}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of workSectionValues | async" [value]="val.workSectionId">
            {{val.workSection}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="jobCategoryId">
    <ng-template viewMode let-element>{{ element.jobCategoryId |
      getText:'jobCategoryId':'jobCategory':jobCategoryValues |
      async}}
    </ng-template>
    <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="top10 fullWidth">
        <mat-label>Job Category</mat-label>
        <mat-select [formControl]="dynamicControl">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of jobCategoryValues | async" [value]="val.jobCategoryId">
            {{val.jobCategory}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of jobCategoryValues | async" [value]="val.jobCategoryId">
            {{val.jobCategory}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="unionAffiliationId">
    <ng-template viewMode let-element>{{ element.unionAffiliationId |
      getText:'unionAffiliationId':'unionAffiliationCode':unionAffiliationValues |
      async}}
    </ng-template>
    <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="top10 fullWidth">
        <mat-label>Union</mat-label>
        <mat-select [formControl]="dynamicControl">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of unionAffiliationValues | async" [value]="val.unionAffiliationId">
            {{val.unionAffiliationCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" class="top20 fullWidth">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let val of unionAffiliationValues | async" [value]="val.unionAffiliationId">
            {{val.unionAffiliationCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

  <aims-common-table-dynamic-row id="color">
    <ng-template viewMode let-element>
      <p [ngStyle]="{'background-color':element.color}">&nbsp;</p>
    </ng-template>
    <ng-template editMode let-dynamicControl="dynamicControl">
      <input matInput type="color" name="color" [formControl]="dynamicControl">
    </ng-template>
  </aims-common-table-dynamic-row>

  <ng-template aimsCommonTableExpandedRow let-element>
    <mat-card>
      <div class="col-xs-6">
        <aims-common-table label="Employee Job Assignment" [id]="'employeeJobAssignments-in-table-' + element.employeeJobAssignmentId"
          [dataSource]="employeeJobAssignmentsResults | filter:'jobTitleId':element.jobTitleId"
          [header]="employeeJobAssignmentsHeader" [pageSize]="5" [permissions]="tablePermissions"
          [addRowInitialObject]="initialEmployeeJobAssignmentTableElement"
          (rowUpdated)="handleEmployeeJobAssignmentRowUpdate($event)"
          (rowAdded)="handleEmployeeJobAssignmentRowAdd($event)">

          <aims-common-table-dynamic-row id="jobTitleId">
            <ng-template viewMode let-element>{{ element.jobTitleId |
              getText:'jobTitleId':'jobTitle':jobTitleValues |
              async}}
            </ng-template>
            <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="top10 fullWidth">
                <mat-label>Job Title</mat-label>
                <mat-select [formControl]="dynamicControl">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of jobTitleValues | async" [value]="val.jobTitleId">
                    {{val.jobTitle}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of jobTitleValues | async" [value]="val.jobTitleId">
                    {{val.jobTitle}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

        </aims-common-table>
      </div>

      <div class="col-xs-6">
        <aims-common-table label="Work Section" [id]="'workSections-in-table-' + element.workSectionId"
          [dataSource]="workSectionsResults | filter:'workSectionId':element.workSectionId"
          [header]="workSectionsHeader" [pageSize]="5" [permissions]="tablePermissions"
          [addRowInitialObject]="initialWorkSectionTableElement" (rowUpdated)="handleWorkSectionRowUpdate($event)"
          (rowAdded)="handleWorkSectionRowAdd($event)">

          <aims-common-table-dynamic-row id="departmentId">
            <ng-template viewMode let-element>{{ element.departmentId |
              getText:'departmentId':'department':departmentValues |
              async}}
            </ng-template>
            <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="top10 fullWidth">
                <mat-label>Department</mat-label>
                <mat-select [formControl]="dynamicControl">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of departmentValues | async" [value]="val.departmentId">
                    {{val.department}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of departmentValues | async" [value]="val.departmentId">
                    {{val.department}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>

          <aims-common-table-dynamic-row id="leadId">
            <ng-template viewMode let-element>{{ element.leadId | getText:'employeeId':'fullName':leadValues |
              async}}
            </ng-template>
            <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
              <mat-form-field appearance="fill" class="top10 fullWidth">
                <mat-label>Work Section Lead</mat-label>
                <mat-select [formControl]="dynamicControl">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of leadValues | async" [value]="val.employeeId">
                    {{val.fullName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
            <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
              <mat-form-field appearance="fill" class="top20 fullWidth">
                <mat-label>Filter</mat-label>
                <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
                  <mat-option label=""></mat-option>
                  <mat-option *ngFor="let val of leadValues | async" [value]="val.employeeId">
                    {{val.fullName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-template>
          </aims-common-table-dynamic-row>
        </aims-common-table>
      </div>
    </mat-card>
  </ng-template>
</aims-common-table>
